export const simbolByType = (type, val) => {
    switch (type) {
        case "porcentaje":
            return `${val}%`
        case "monto_fijo":
            return `$${val}`
        default:
            return val
    }
}